import script from "./SEOHeadTags.vue?vue&type=script&lang=js"
export * from "./SEOHeadTags.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__